module.exports = __webpack_public_path__ + "static/media/mohammadJundiSmiling.ffeb3154.jpg";